import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		dailyReport: {}
	},

	actions: {
		fetchMine({ commit }) {
			return window.axios.get('/dailyReport/mine', { preventHandling: true }).then(({ data }) => {
				commit(types.STORE_DAILY_REPORT, data);
				return data;
			}).catch(() => null);
		},
		
		create({ commit }, { classification, report }) {
			return window.axios.post('/dailyReport', null, {
				params: { classification, report }
			}).then(({ data }) => data);
		},

		update({ commit }, { id, classification, report }) {
			return window.axios.put('/dailyReport', null, {
				params: { id, classification, report }
			});
		},

		delete({ commit }, { id, classification, report }) {
			return window.axios.delete('/dailyReport', null, { params: { id } });
		},
	},

	mutations: {
		[types.STORE_DAILY_REPORT](state, dailyReport) {
			state.dailyReport = dailyReport || {};
		}
	},
}